export default __webpack_public_path__ + "static/media/warning--snowmobiles-and-others--g1.8d956ed3.png";